/* import __COLOCATED_TEMPLATE__ from './currency-input.hbs'; */
var _dec, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import Money from '@square/dashboard-money/models/money';
import { later } from '@ember/runloop';
var countryCodeToCurrencySymbol = /*#__PURE__*/function (countryCodeToCurrencySymbol) {
  countryCodeToCurrencySymbol["USD"] = "$";
  countryCodeToCurrencySymbol["CAD"] = "$";
  countryCodeToCurrencySymbol["AUD"] = "$";
  countryCodeToCurrencySymbol["EUR"] = "\u20AC";
  countryCodeToCurrencySymbol["GBP"] = "\xA3";
  countryCodeToCurrencySymbol["JPY"] = "\xA5";
  return countryCodeToCurrencySymbol;
}(countryCodeToCurrencySymbol || {});
let CurrencyInput = (_dec = computed('args.amount'), _class = class CurrencyInput extends Component {
  get countryCodeByCurrencyCode() {
    // this.amount.currencyCode has already been converted to a dashboard-money
    // type (e.g., currencyCode: "USD") via the amount getter below.
    if (this.amount?.currencyCode) {
      return this.amount?.currencyCode;
    }
    return Money.defaultCurrencyCode;
  }
  get currencySymbol() {
    const countryCode = this.countryCodeByCurrencyCode;
    return countryCodeToCurrencySymbol[countryCode] ?? countryCodeToCurrencySymbol[Money.defaultCurrencyCode];
  }
  get amount() {
    return Money.fromConnectProto(this.args.amount);
  }
  setAmount(amount) {
    this.args.setAmount(amount && amount.toConnectProto());
  }
  onInsert(el) {
    later(() => {
      let input;
      if (el.shadowRoot) {
        input = el.shadowRoot.querySelector('input');
      } else {
        input = el.querySelector('market-input-text')?.shadowRoot?.querySelector('input') || null;
      }
      if (input) {
        input.focus();
      }
    }, 1);
  }
}, _applyDecoratedDescriptor(_class.prototype, "amount", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "amount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAmount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _class);
export { CurrencyInput as default };